module.exports = __webpack_public_path__ + "static/media/NoDataIcon.f1379aef.svg";